import {loginActions} from './actions';

let user = JSON.parse(sessionStorage.getItem('user'));
const initialState = user ? {user} : {user: {}};

export default function authentication(state = initialState, action) {
  switch (action.type) {
    case loginActions.LOGIN_REQUEST:
      return {
        user: action.user,
      };
    case loginActions.LOGIN_SUCCESS:
      return {
        user: action.user,
      };
    case loginActions.LOGIN_FAILURE:
      return {
        error: action.error,
      };
    case loginActions.LOGOUT:
      return {
        user: {},
      };
    default:
      return state;
  }
}
